import { List, ListItem, ListItemButton } from 'components/ui';
import theme from 'theme';
import styled from 'styled-components';

export const IndexListItemButton = styled(ListItemButton)`
  margin-bottom: ${theme.padding.content};
  background-color: ${theme.palette.primary.white};
  border-radius: ${theme.radius.card};
  border: 1px solid ${theme.palette.divider};
  display: block;

  &:hover {
    background-color: ${theme.palette.action.hover};
  }

  &.overdue::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 4px;
    height: 100%;
    background-color: ${theme.palette.error.main};
    border-top-left-radius: ${theme.radius.card};
    border-bottom-left-radius: ${theme.radius.card};
  }
  &.incoming::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 4px;
    height: 100%;
    background-color: ${theme.palette.warning.main};
    border-top-left-radius: ${theme.radius.card};
    border-bottom-left-radius: ${theme.radius.card};
  }
`;

export const IndexListItem = styled(ListItem)`
  margin-bottom: ${theme.padding.content};
  border: 1px solid ${theme.palette.divider};
  background-color: ${theme.palette.primary.white};
  border-radius: ${theme.radius.card};
  display: block;
`;

export const FieldsList = styled(List)`
  display: inline-grid;
  li {
    padding: 0;
  }
`;

export const FieldsListItem = styled(ListItem)`
  > span {
    padding-right: ${theme.padding.content};
  }
`;

export const IndexListItemHeader = styled(ListItem)`
  display: block;
`;
